import { logger } from "./logger";

let initialized = false;

/**
 * Registers window-level crash catchers once. Call this a single time from
 * the app entrypoint (src/index.tsx), before rendering.
 */
export const initGlobalErrorLogging = () => {
  if (initialized) return;
  initialized = true;

  window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    logger.unhandledRejection({
      message: reason?.message || String(reason),
      stack: reason?.stack,
    });
  });

  window.addEventListener("error", (event: ErrorEvent) => {
    logger.error(event.message || "Unknown error", {
      source: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error?.stack,
    });
  });
};
